import React, { useState } from "react";
import "./FAQ.css";

const faqData = [
  {
    question: "What services does your company provide?",
    answer:
      "We offer end-to-end IT solutions including web development, mobile app development, UI/UX design, cloud solutions, and custom software development tailored to client needs.",
  },
  {
    question: "Do you work with startups and enterprises?",
    answer:
      "Yes! We collaborate with startups, SMEs, and enterprises, delivering scalable solutions that adapt to business growth.",
  },
  {
    question: "How long does it take to deliver a project?",
    answer:
      "Timelines depend on complexity—MVPs usually take 4–8 weeks, while larger solutions may require 3–6 months with continuous client collaboration.",
  },
  {
    question: "Do you provide ongoing support after delivery?",
    answer:
      "Absolutely. We provide maintenance, security updates, feature enhancements, and performance monitoring to ensure your product stays updated.",
  },
  {
    question: "Why should we choose your company?",
    answer:
      "We combine technical expertise, transparent communication, and cost-effective solutions with a passion for helping businesses grow. Our work speaks through the success of our clients.",
  },
  {
    question: "How can we start working together?",
    answer:
      "You can reach us through our Contact page. Our team will connect with you to understand your requirements and provide the right proposal.",
  },
];

const FAQ = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section className="faq-section" id="faq">
      <h2 className="faq-title">
        Frequently Asked Questions
        <span className="faq-underline"></span>
      </h2>

      <div className="faq-container">
        {faqData.map((item, index) => (
          <div
            key={index}
            className={`faq-item ${activeIndex === index ? "active" : ""}`}
          >
            <div
              className="faq-question"
              onClick={() => toggleFAQ(index)}
            >
              {item.question}
              <span className="faq-icon">
                {activeIndex === index ? "▲" : "▼"}
              </span>
            </div>
            <div
              className="faq-answer"
              style={{
                maxHeight: activeIndex === index ? "300px" : "0",
              }}
            >
              <p>{item.answer}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default FAQ;
